<template>
  <v-layout
    class="splash-screen-wrapper d-flex flex-column"
    fill-height
    align-center
    justify-center
  >
    <div class="neutral6--text">powerd by</div>
    <div class="text-h4 font-weight-black russo-one">Gainmes</div>
  </v-layout>
</template>

<script>
export default {
  name: "SplashScreen",
};
</script>

<style src="./style.scss" lang="scss" scoped />
